import styled from 'styled-components';

const SectionHeader = styled.div`
    color: #C2C2C2;
    font-family: GothamBook;
    font-size: 18px;
    font-weight: 300;
    line-height: 22px;
`;

export const ReportSectionHeader = styled(SectionHeader)`
    height: 29px;
    padding-top: 40px;
    padding-bottom: 25px;
`;

export const CommissionHeaders = styled(SectionHeader)`
    height: 16px;
    padding-bottom: 25px;
`;



// WEBPACK FOOTER //
// ./src/common/components/SectionHeader.js